import classNames from "classnames";
import * as React from "react";
import { Helmet } from "react-helmet";
import styles from "./index.module.css";

interface DefaultLayoutProps extends React.HTMLProps<HTMLDivElement> {
    children: any;
}

export default class extends React.PureComponent<DefaultLayoutProps> {
    public render() {
        const { className, children, ...restProps } = this.props;
        return (
            <div className={classNames(styles.container, className)} {...restProps}>
                <Helmet
                    meta={[
                        {
                            name: "description",
                            content: "digital dance hall",
                        },
                        {
                            name: "keywords",
                            content: ["digital", "dance hall", "party", "club", "livestream", "music"].join(),
                        },
                        {
                            property: "og:type",
                            content: "website",
                        },
                        {
                            property: "og:title",
                            content: "digital dance hall",
                        },
                        // {
                        //     property: "og:description",
                        //     content: "",
                        // },
                        // {
                        //     property: "og:image",
                        //     content: "",
                        // },
                        // { property: "og:image:width", content: "500px" },
                        // { property: "og:image:height", content: "209px" },
                    ]}
                    link={[
                        {
                            href: "https://fonts.googleapis.com/css2?family=Manrope:wght@400;700&display=swap",
                            rel: "stylesheet",
                        },
                    ]}
                />
                {children}
            </div>
        );
    }
}
